import { getDefaultContentRecords } from '@/lib/default-content';
import type { ContentKind, ContentRecord } from '@/lib/content-types';
import { pageCopyDefaults } from '@/lib/site-data';

let records: ContentRecord[] = getDefaultContentRecords();
export function setPublicRecords(next: ContentRecord[]) { records = next; }
export async function getMergedContentRecords(options?: { includeArchived?: boolean }) {
  return records.filter(r => options?.includeArchived || r.status !== 'archived').sort((a, b) => a.kind.localeCompare(b.kind) || a.sortOrder - b.sortOrder || a.title.localeCompare(b.title, 'hu'));
}
export async function getPublishedContent(kind: ContentKind) {
  return (await getMergedContentRecords()).filter(r => r.kind === kind && r.status === 'published');
}
export async function getPageCopy(slug: keyof typeof pageCopyDefaults) {
  const found = records.find(r => r.id === `page-${slug}` && r.status === 'published');
  const fallback = getDefaultContentRecords().find(r => r.id === `page-${slug}`)!;
  const selected = found ?? fallback;
  return { eyebrow: String(selected.data.eyebrow ?? ''), title: selected.title, description: String(selected.data.description ?? ''), body: String(selected.data.body ?? '') };
}
